export default "__VITE_ASSET__BphGsVT6__"